import React from 'react';
import { Icon, Table } from 'semantic-ui-react';

import './technicals-infos.scss';

import exposureData from '../../../../../../../data/exposureDatas'

const TechnicalsInfos = ({ data }) => {
  const isEmpty = (value) =>
    value === null ||
    value === undefined ||
    value === '' ||
    value === 'null' ||
    value === 'undefined';

  const safeText = (value) => (isEmpty(value) ? '--' : String(value));

  const toNumber = (value) => {
    if (isEmpty(value)) {
      return null;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  };

  const exposureKey = !isEmpty(data?.exposure) ? String(data.exposure) : null;
  const exposureValue = exposureKey && exposureData[exposureKey]?.value
    ? exposureData[exposureKey].value
    : '--';

  const make = safeText(data?.make);
  const model = safeText(data?.model);
  const lensModel = safeText(data?.lensModel ?? data?.lensmodel);
  const fNumber = toNumber(data?.fnumber);
  const focalDistance = toNumber(data?.focaldistance ?? data?.focalDistance);
  const iso = toNumber(data?.iso);

  return (

    <div id="technicals-infos">
      <Table unstackable celled striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell colSpan='2'>TECHNICALS INFOS</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell className='custom-aligned'>
            <Icon className='icon-table' name='camera' /> Camera
            </Table.Cell>
            <Table.Cell>
              {make} {model}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell className='custom-aligned'>
            <Icon className='icon-table' name='search' /> Lens Model
            </Table.Cell>
            <Table.Cell>
              {lensModel}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell className='custom-aligned'>
            <Icon className='icon-table' name='clock outline' /> Exposure
            </Table.Cell>
            <Table.Cell>
              {exposureValue}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell className='custom-aligned'>
            <Icon className='icon-table' name='adjust' /> Aperture
            </Table.Cell>
            <Table.Cell>
              {fNumber !== null ? `f/${fNumber}` : '--'}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell className='custom-aligned'>
            <Icon className='icon-table' name='crosshairs' /> Focale Distance
            </Table.Cell>
            <Table.Cell>
              {focalDistance !== null ? `${focalDistance}mm` : '--'}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell className='custom-aligned'>
            <Icon className='icon-table' name='sun' /> ISO
            </Table.Cell>
            <Table.Cell>
              {iso !== null ? iso : '--'}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </div>
  );
};

export default TechnicalsInfos;
